<template>
  <div class="product-info-sheet__contain">
    <p class="sheet-title">{{ productDetailTitle }}</p>

    <div id="productInfoSheet__sheetContent" class="sheet-content">
      <p v-if="product.description" class="product-info-description !wd-mb-0 wd-py-4" v-html="nl2br(product.description)" />

      <!-- FunNow 禮遇 -->
      <template v-if="shouldRewardShow">
        <p class="sheet-title wd-text-otemplg">{{ $t('product_detail_special_gift') }}</p>

        <div class="wd-pt-4 <xs:wd-py-4">
          <div
            v-for="rewardInfo in rewardUiCards"
            :key="rewardInfo.title"
            class="rewardCard wd-rounded-4px wd-p-4 wd-flex wd-justify-between"
            :class="rewardInfo.backgroundColorClass"
          >
            <div :class="{ 'wd-mr-2': rewardInfo.isLocked }">
              <p class="!wd-mb-2 wd-text-otempsm" :class="rewardInfo.foregroundColorClass">{{ rewardInfo.title }}</p>
              <p class="!wd-mb-0 wd-text-otempsm" v-html="rewardInfo.content" />
            </div>
            <FunnowSvgIcon
              v-if="rewardInfo.isLocked"
              class="wd-self-center"
              :class="rewardInfo.foregroundColorClass"
              max-width="20"
              image-path="lock-icon.svg"
            />
          </div>
        </div>

        <v-btn v-if="showVIPBtn" class="action__btn mt-3" color="orange50" variant="text"> {{ $t('how_to_be_vip') }} </v-btn>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import utils from '@/utils'
import { MembershipLevel } from '@/view-models/member'
import { useUserInfo } from '@/composition/useMember'

import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'

interface RewardUiCard {
  title: string
  content: string
  backgroundColorClass: string
  foregroundColorClass: string
  isLocked: boolean
}

export default defineComponent({
  name: 'ProductInfoSheet',
  components: {
    FunnowSvgIcon,
  },
  props: {
    product: { type: Object, default: () => ({}) },
    shouldRewardHide: { type: Boolean, default: false },
  },
  setup(props) {
    const nuxtApp = useNuxtApp()

    const { productDetailTitle } = usePlatformProductContext()

    const showVIPBtn = ref(false) // TODO: 暫時關閉, 等會員頁出來
    const shouldRewardShow = computed(() => !!(memberReward.value || vipReward.value) && !props.shouldRewardHide)
    const memberReward = computed(() => props.product.member_reward)
    const vipReward = computed(() => props.product.vip_reward)

    const { userInfo } = useUserInfo()
    const rewardUiCards = computed(() => {
      let res: RewardUiCard[] = []
      const level = userInfo.value?.benefit?.level
      const isElite = level === MembershipLevel.Elite

      if (memberReward.value) {
        res = [
          ...res,
          {
            title: nuxtApp.$i18n.t('special_gift_general') as string,
            content: utils.nl2br(memberReward.value),
            backgroundColorClass: 'wd-bg-orange10',
            foregroundColorClass: 'wd-text-orange50',
            isLocked: false,
          },
        ]
      }
      if (vipReward.value) {
        res = [
          ...res,
          {
            title: nuxtApp.$i18n.t('special_gift_pro_elite') as string,
            content: utils.nl2br(vipReward.value),
            backgroundColorClass: isElite ? 'wd-bg-pink20' : 'wd-bg-brown20',
            foregroundColorClass: isElite ? 'wd-text-pink60' : 'wd-text-brown60',
            isLocked: level !== MembershipLevel.Elite && level !== MembershipLevel.Pro,
          },
        ]
      }

      return res
    })

    return {
      nl2br: utils.nl2br,
      shouldRewardShow,
      rewardUiCards,
      showVIPBtn,
      productDetailTitle,
    }
  },
})
</script>

<style lang="scss" scoped>
.rewardCard:not(:last-child) {
  @apply wd-mb-2;
}

@include xxs {
  #productInfoSheet__sheetContent {
    margin: 0;
  }
}
</style>
